import { render } from "./MetawebUpdateChangedLists.vue?vue&type=template&id=130ee02e&ts=true"
import script from "./MetawebUpdateChangedLists.vue?vue&type=script&lang=ts"
export * from "./MetawebUpdateChangedLists.vue?vue&type=script&lang=ts"

import "./MetawebUpdateChangedLists.vue?vue&type=style&index=0&id=130ee02e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__